module.exports = __webpack_public_path__ + "06_short_black.2bc09921.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_short_black.png
// module id = +S95
// module chunks = 0